import '../../assets/css/login.css';
import '../../index.css';
import React from 'react';
import { Icons } from '../../assets/SvgIcons';
import { ToastContainer } from 'react-toastify';

export interface AuthTemplateProps {
  headerText?: React.ReactNode;
  children?: React.ReactNode;
}

export default function AuthTemplate({
  headerText,
  children,
}: AuthTemplateProps) {
  return (
    <div className="centered loginWraper">
      <div className="auth_container">
        <div className="auth_header">
          <div className="logoBg">
            <Icons.LogoBlue />
          </div>
        </div>
        <div className="login_header">
          <div className="loginMiddleText">{headerText}</div>
        </div>
        <div>{children}</div>
      </div>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
      />
    </div>
  );
}
